import { Button, Grid, Stack } from '@mui/material'
import axios from 'axios';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { CHANGE_ALL_PREDICTION_STATUS } from '../constant/endpoint';
import Swal from 'sweetalert2';

function PredictionNvigation({match_id, series_id, sport, type, refetch}) {
    const navigate = useNavigate();
    
    const RedirectFun = (match_id, series_id, name) => {
        navigate(`/matchlist/${name}/${match_id}/${series_id}/${sport}`)
    }

    const changeStatusForAll = async (status, statusType) => {
        const resultCheck = await Swal.fire({
            title: `Do you want to change Status?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are Changing the Status',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(CHANGE_ALL_PREDICTION_STATUS.replace(':match_id', match_id).replace(':sport', sport).replace(':status', status))
            if (result.data.status === "success") {
                Swal.close()
                refetch()
                Swal.fire({
                    title: `Status Changed Successfully to ${statusType}`,
                    icon: 'success',
                    position: 'top-end',
                    timer: 1500,
                    showConfirmButton: false
                })
            }
        }
    }

    return (
        <>
          {type === 'trading' && <><Grid item spacing={3}>
                <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                    <Button variant={'contained'} color="primary" style={{ background: "green", color: "#fff", marginRight: "10px" }} onClick={() => changeStatusForAll(0, 'Active')}>Active</Button>
                </Stack>
            </Grid>
            <Grid item spacing={3}>
                <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                    <Button variant={'contained'} color="primary" style={{ background: "red", color: "#fff", marginRight: "10px" }} onClick={() => changeStatusForAll(1, 'Inactive')}>Inactive</Button>
                </Stack>
            </Grid>  </>}
            {/* <Grid item spacing={3}>
                <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                    <Button variant={'contained'} color="primary" style={{ background: "#ADDFFF", color: "black", marginRight: "10px" }} onClick={() => RedirectFun(match_id, series_id, 'poll')}>Poll</Button>
                </Stack>
            </Grid>
            <Grid item spacing={3}>
                <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                    <Button variant={'contained'} color="primary" style={{ background: "#ADDFFF", color: "black", marginRight: "10px" }} onClick={() => RedirectFun(match_id, series_id, 'opinion_pro')}>Opinion Pro</Button>
                </Stack>
            </Grid> */}
            <Grid item spacing={3}>
                <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                    <Button variant={'contained'} color="primary" style={{ background: "#ADDFFF", color: "black", marginRight: "10px" }} onClick={() => RedirectFun(match_id, series_id, 'trading')}>Trading</Button>
                </Stack>
            </Grid>
            <Grid item spacing={3}>
                <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                    <Button variant={'contained'} color="primary" style={{ background: "#ADDFFF", color: "black", marginRight: "10px" }} onClick={() => RedirectFun(match_id, series_id, 'in_play')}>Quiz Play</Button>
                </Stack>
            </Grid>
            <Grid item spacing={3}>
                <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                    <Button variant={'contained'} color="primary" style={{ background: "#ADDFFF", color: "black", marginRight: "10px" }} onClick={() => RedirectFun(match_id, series_id, 'skiller')}>Skiller</Button>
                </Stack>
            </Grid>
        </>
    )
}

export default PredictionNvigation